import { Injectable, OnDestroy } from '@angular/core';
import { Headers, Http, Request, RequestMethod, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import { BaseHttpService } from './base-http.service';
import { AuthService } from './auth.service';
import { LoggerService } from './logger.service';
import * as fromRoot from '../store/reducers';
import { AppUiActions } from '../store/actions';


@Injectable()
export class ScoringPageService extends BaseHttpService implements OnDestroy {

    constructor(
        http: Http,
        httpClient: HttpClient,
        store: Store<fromRoot.State>,
        loggerService: LoggerService,
        authService: AuthService
    ) {
        super(http, httpClient, store, loggerService, authService);
    }

    ngOnDestroy() {
    }
}




// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/scoring-page.service.ts